// api/crop-tracker.ts

import { apiProvider } from "./utilities/provider";
import { CropTrackerRow } from "../../models/crop-tracker";

export const cropTrackerApi = {
  getAll: (): Promise<CropTrackerRow[]> =>
    apiProvider.getAll("crop-tracker").then((d) => d?.data ?? []),

  archive: async (cropCycleIds: number[]) => {
    await apiProvider.patch("crop-tracker/archive", undefined, {
      cropCycleIds,
    });
  },

  unarchive: async (cropCycleIds: number[]) => {
    await apiProvider.patch("crop-tracker/archive", undefined, {
      cropCycleIds,
      unarchive: true,
    });
  },
};
